<template>
  <section class="form-login">
    <Loader v-if="loading" />

    <b-form class="custom-form text-left" @submit.prevent="submit">
      <div class="form-group">
        <label for="email">Correo electrónico</label>

        <FormInput id="email" type="email" maxlength="100" placeholder="Ingresa tu correo electrónico" :show-error="$v.form.username.$error && !$v.form.username.required" v-model="form.username" />

        <form-error message="Correo electrónico es requerido" v-if="$v.form.username.$error && !$v.form.username.required"></form-error>
      </div>

      <div class="form-group">
        <label for="password">Contraseña</label>

        <FormInput id="password" type="password" placeholder="Ingresa tu contraseña" :show-error="$v.form.password.$error && !$v.form.password.required" v-model="form.password" />

        <form-error message="Contraseña es requerida" v-if="$v.form.password.$error && !$v.form.password.required"></form-error>

        <form-error :message="error" v-if="error"></form-error>
      </div>

      <div class="form-group my-4">
        <b-form-checkbox id="clear-all-check" v-model="form.remember">
          <span class="font-weight-medium custom-checkbox-label">Recordar datos</span>
        </b-form-checkbox>
      </div>

      <b-button class="button button-primary" type="submit" variant="none" block>Ingresar </b-button>

      <div class="d-flex justify-content-center align-items-center w-100 text-center">
        <a href="" class="text-color-primary font-weight-light ml-2" @click.prevent="$emit('reset')">¿Olvidaste tu contraseña?</a>
      </div>
    </b-form>
  </section>
</template>

<script>
import { FormError, FormInput, Loader } from "wize-admin";
import { required } from "vuelidate/lib/validators";

import { SecurityService } from "@/core/services";

export default {
  components: {
    FormError,
    Loader,
    FormInput,
  },
  data() {
    return {
      form: {
        username: null,
        password: null,
        remember: false,
      },
      loading: false,
      error: null,
    };
  },
  validations: {
    form: {
      username: {
        required,
      },
      password: {
        required,
      },
    },
  },
  methods: {
    async submit() {
      this.$v.form.$touch();
      if (this.$v.form.$anyError) {
        return;
      }

      // await this.$recaptchaLoaded()
      // const token = await this.$recaptcha('login')

      try {
        this.error = null;
        this.loading = true;
        // const resp = await SecurityService.login({ ...this.form, recaptcha: token });
        const resp = await SecurityService.login({ ...this.form });
        this.$store.dispatch("auth/setAccessToken", resp.payload.token);
        const user = await this.$store.dispatch("auth/setUser");
        this.loading = false;
        const role = user.role || user.profile;
        if (role === 'AFFILIATE') {
          await this.$router.push({ name: "AffiliateDashboard" });
        } else {
          // El admin elige nivel (Administración o ciudad) antes de operar — DEF-ADM-009
          await this.$store.dispatch("city/clearLevel");
          await this.$router.push({ name: "city-selector" });
        }
      } catch (e) {
        console.error(e);
        if(e.errors && e.errors.message) {
          this.error = e.errors.message;

          if(this.error == 'user is disabled') {
            this.error = 'El usuario se encuentra deshabilitado. Por favor, contacte al administrador.'
          } else if(this.error == 'invalid username or password') {
            this.error = 'Credenciales inválidas. Por favor, verifique e intente nuevamente.'
          }
        } else {
          this.error = "Hubo un error al intentar autenticar";
        }
      } finally {
        this.loading = false;
      }
    },
    showRecaptchaBadge() {
      if (this.$recaptchaInstance) {
        this.$recaptchaInstance.showBadge();
      } else {
        setTimeout(() => {
          this.showRecaptchaBadge();
        }, 500);
      }
    },
  },
  mounted() {
    // this.showRecaptchaBadge();
  },
};
</script>

<style lang="stylus">
@import './form-login';
</style>
